
import dummyPhoto from "../assests/dummy_image.jpg";

export const previewWithPrefix = (filePath: string | null): string => {
    return filePath && filePath.length > 0 && filePath !== dummyPhoto ? `${process.env.REACT_APP_S3_PUBLIC_PREFIX_URL}${filePath}` : dummyPhoto
}